import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { AddService } from '../shared/services/userservices/add.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AttendanceService } from '../shared/services/attendanceservices/attendance.service';
import { DashboardService } from '../shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from '../shared/services/shared-mode.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from '../shared/components/loader/loader.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-bulk-attendance-edit',
  templateUrl: './bulk-attendance-edit.component.html',
  styleUrls: ['./bulk-attendance-edit.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, LoaderComponent, RouterModule],
  providers: [DatePipe],
  animations: [
    trigger('slideDown', [
      state('collapsed', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: '1',
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class BulkAttendanceEditComponent implements OnInit {
  public showSpinner = true;
  userAttendance: any[] = [];
  pagedData: any[] = [];
  originalPagedData: any[] = [];
  
  nameFilter: any = '';
  attendanceidFilter: any = '';
  startDateFilter: Date | null = new Date();
  endDateFilter: Date | null = new Date();
  
  sortType = '';
  sortdepartment = '';
  sortBy = '';
  
  departments: any[] = [];
  selectedMode: any;
  user: any;
  todayStr = '';
  
  bulkEditReason = '';
  canEditShiftTimes = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    private _location: Location,
    private addService: AddService,
    private attendanceservice: AttendanceService,
    private datePipe: DatePipe,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    const user_role = JSON.parse(this.user?.user_role?.user_roles || '{}');
    this.canEditShiftTimes = user_role?.role_type === 'Admin';
    
    const today = new Date();
    this.todayStr = this.formatDate(today);
    this.startDateFilter = today;
    this.endDateFilter = today;
  }

  ngOnInit(): void {
    debugger
     this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getData();
    this.getAttendance();
  }

  getData() {
    this.addService.getStaticData().then((value) => {
      this.departments = value.data.departments;
    });
  }

  getAttendance() {
    this.showSpinner = true;
    const sdate = this.startDateFilter ? this.formatDate(this.startDateFilter) : '';
    const edate = this.endDateFilter ? this.formatDate(this.endDateFilter) : '';
    
    this.attendanceservice.getAttendancefilter(
      this.nameFilter,
      sdate,
      edate,
      this.attendanceidFilter,
      this.sortType,
      this.sortdepartment,
      this.sortBy
    ).then((value) => {
      this.userAttendance = value.data;
      this.setupData();
      this.showSpinner = false;
    }).catch(err => {
      this.showSpinner = false;
      console.error(err);
    });
  }

  setupData() {
    const temp_array: any[] = [];
    let indexCount = 0;
    let lastDate = "";
    let lastUserID = 0;
    let totalHours = 0;
    let off_day = 0;
    let singleArray: any[] = [];

    for (const data of this.userAttendance) {
      if (indexCount === 0) {
        totalHours += data.total_hours ?? 0;
        lastDate = data.date;
        off_day = data.off_day;
        lastUserID = data.user_id;
        singleArray.push(data);
        if (indexCount === this.userAttendance.length - 1) {
          temp_array.push({ "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day });
        }
      } else {
        if (data.date === lastDate && data.user_id === lastUserID) {
          totalHours += data.total_hours ?? 0;
          singleArray.push(data);
          if (indexCount === this.userAttendance.length - 1) {
            temp_array.push({ "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day });
          }
        } else {
          temp_array.push({ "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day });
          singleArray = [];
          lastDate = data.date;
          lastUserID = data.user_id;
          off_day = data.off_day;
          totalHours = data.total_hours ?? 0;
          singleArray.push(data);
          if (indexCount === this.userAttendance.length - 1) {
            temp_array.push({ "total_hours": totalHours ?? 0, "data": singleArray, "off_day": off_day });
          }
        }
      }
      indexCount++;
    }

    this.pagedData = temp_array;
    this.originalPagedData = JSON.parse(JSON.stringify(this.pagedData));
  }

  applyFilter() {
    if (this.endDateFilter && this.startDateFilter && this.endDateFilter < this.startDateFilter) {
      Swal.fire({
        iconHtml: '<img src="../../assets/images/error-modal.svg">',
        title: 'Invalid Date Range',
        text: 'End date cannot be earlier than start date',
        confirmButtonText: 'OK'
      });
      return;
    }
    this.getAttendance();
  }

  resetFilter() {
    this.nameFilter = '';
    this.attendanceidFilter = '';
    const today = new Date();
    this.startDateFilter = today;
    this.endDateFilter = today;
    this.sortType = '';
    this.sortdepartment = '';
    this.sortBy = '';
    this.getAttendance();
  }

  saveBulkEdit() {
    if ((this.bulkEditReason || '').trim().length < 50) {
      Swal.fire({
        iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
        title: 'Validation Error',
        text: 'Reason must be at least 50 characters long.',
        showConfirmButton: true,
      });
      return;
    }

    const modifiedAttendances: any[] = [];

    this.pagedData.forEach((record, recordIndex) => {
      record.data.forEach((obj: any, objIndex: number) => {
        const origRecord = this.originalPagedData[recordIndex];
        const origObj = origRecord && origRecord.data ? origRecord.data[objIndex] : null;

        if (origObj) {
          const checkInChanged = obj.check_in !== origObj.check_in;
          const checkOutChanged = obj.check_out !== origObj.check_out;
          const totalHoursChanged = obj.total_hours != origObj.total_hours;
          const overtimeChanged = obj.overtime != origObj.overtime;
          const shiftStartChanged = obj.shift_start_time !== origObj.shift_start_time;
          const shiftEndChanged = obj.shift_end_time !== origObj.shift_end_time;

          if (checkInChanged || checkOutChanged || totalHoursChanged || overtimeChanged || shiftStartChanged || shiftEndChanged) {
            modifiedAttendances.push({
              id: obj.id,
              check_in: obj.check_in,
              check_out: obj.check_out,
              total_hours: obj.total_hours,
              overtime: obj.overtime,
              shift_start_time: obj.shift_start_time,
              shift_end_time: obj.shift_end_time,
              total_working_hours: obj.total_working_hours
            });
          }
        }
      });
    });

    if (modifiedAttendances.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Changes Detected',
        text: 'You have not modified any attendance records.',
      });
      return;
    }

    this.showSpinner = true;
    const payload = {
      attendances: modifiedAttendances,
      reason: this.bulkEditReason
    };

    this.addService.updateBulkAttendance(payload).then((res: any) => {
      this.showSpinner = false;
      if (res && res.success) {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="success">',
          title: 'Bulk Edit Successful',
          showConfirmButton: false,
          timer: 2000
        });
        this.router.navigate(['/attendance-management']);
      } else {
        Swal.fire({
          iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
          title: 'Update Failed',
          text: res?.message || 'Could not update records.',
        });
      }
    }).catch(err => {
      this.showSpinner = false;
      Swal.fire({
        iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
        title: 'Error',
        text: 'An error occurred during update.',
      });
    });
  }

  cancel() {
    this.router.navigate(['/attendance-management']);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`;
  }

  formatDisplay(d: Date | null): string {
    return d ? (this.datePipe.transform(d, 'd MMM yyyy') ?? '') : '';
  }

  formatNative(d: Date | null): string {
    return d ? (this.datePipe.transform(d, 'yyyy-MM-dd') ?? '') : '';
  }

  parseDate(dateString: string): Date | null {
    if (!dateString) return null;
    // Handle "YYYY/MM/DD" format from API
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // JavaScript months are 0-based
      const day = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    return null;
  }

  calculateBulkWorkingHours(obj: any) {
    if (obj.check_in && obj.check_out) {
      // Split the times into hours and minutes
      const [inH, inM] = obj.check_in.split(':').map(Number);
      const [outH, outM] = obj.check_out.split(':').map(Number);

      if (!isNaN(inH) && !isNaN(inM) && !isNaN(outH) && !isNaN(outM)) {
        const startMinutes = inH * 60 + inM;
        let endMinutes = outH * 60 + outM;

        // Handle overnight shift if necessary (though usually check-in/out is same day in this app)
        if (endMinutes < startMinutes) {
          endMinutes += 24 * 60;
        }

        const totalMinutes = endMinutes - startMinutes;
        const hours = totalMinutes / 60;
        obj.total_hours = parseFloat(hours.toFixed(2));
      } else {
        obj.total_hours = 0;
      }
    } else {
      obj.total_hours = 0;
    }
  }

  applyStart(e: Event) {
    const val = (e.target as HTMLInputElement).value;
    if (val) {
      const [year, month, day] = val.split('-').map(Number);
      this.startDateFilter = new Date(year, month - 1, day);
    } else {
      this.startDateFilter = null;
    }
    // this.applyFilter();
  }

  applyEnd(e: Event) {
    const val = (e.target as HTMLInputElement).value;
    if (val) {
      const [year, month, day] = val.split('-').map(Number);
      this.endDateFilter = new Date(year, month - 1, day);
    } else {
      this.endDateFilter = null;
    }
    // this.applyFilter();
  }

  deleteRecord(obj: any, recordIndex: number, objIndex: number) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to delete this attendance record!",
      iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.showSpinner = true;
        this.attendanceservice.deleteAttendance(obj.id).then((res: any) => {
          this.showSpinner = false;
          if (res && res.success) {
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/success-modal.svg" alt="success">',
              title: 'Deleted!',
              text: 'The record has been deleted.',
              showConfirmButton: false,
              timer: 1500
            });
            
            // Remove from local data
            this.pagedData[recordIndex].data.splice(objIndex, 1);
            
            // Also update originalPagedData to keep consistency
            if (this.originalPagedData[recordIndex] && this.originalPagedData[recordIndex].data) {
              this.originalPagedData[recordIndex].data.splice(objIndex, 1);
            }

            // If no more sub-records for this date/user, remove the entire record from pagedData
            if (this.pagedData[recordIndex].data.length === 0) {
              this.pagedData.splice(recordIndex, 1);
              this.originalPagedData.splice(recordIndex, 1);
            }
          } else {
            Swal.fire({
              iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
              title: 'Error!',
              text: res?.message || 'Could not delete the record.',
            });
          }
        }).catch(err => {
          this.showSpinner = false;
          Swal.fire({
            iconHtml: '<img src="../../../../assets/images/error-modal.svg" alt="error">',
            title: 'Error!',
            text: 'An error occurred while deleting.',
          });
        });
      }
    });
  }
  
}
